import { useEffect } from "react";
import { faMagnifyingGlass, faFilter } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useCallback, useState } from "react";
import { getDataTestAttribute } from "utils/dataTestAttribute";
import "./SearchBox.scss";
import useSearchByDelay from "hooks/useSearchByDelay";

const SearchBox = ({ handleClick, handleKeyDown = null, clear = false, isFilter = false, placeholder = null, ...dataTest }) => {
	const [searchValue, setSearchValue] = useState("");
	const [hasAiSearch, setHasAiSearch] = useState(false);

	useEffect(() => {
		const value = sessionStorage.getItem("hasAiSearch");
		setHasAiSearch(value === "true");
	}, []);

	useEffect(() => {
		if (clear) {
			setSearchValue("");
		}
	}, [clear]);

	const searchByKeyDown = useCallback((value) => {
		if (handleKeyDown) {
			handleKeyDown(value);
		}
	}, [handleKeyDown]);

	const searchByClick = useCallback((value) => {
		if (value.length && handleClick) {
			handleClick(value);
		}
	}, [handleClick]);
	
	useSearchByDelay(searchValue, searchByKeyDown);
	
	const handleChangeInput = (e) => {
		setSearchValue(e.target.value);
	};

	const handleKeyDownInput = (e) => {
		if (e.key === 'Enter') {
			searchByClick(searchValue);
		}
	};

	const placeholderText = placeholder ?? (hasAiSearch ? "How can I help?" : "Search");
	const dataTestAttribute = getDataTestAttribute(dataTest);

	return (
		<div className={`searchbox${isFilter ? " is-filter" : ""}`}>
			<input
				name="searchbox-input"
				className="searchbox-input"
				type="text"
				placeholder={placeholderText}
				value={searchValue}
				onChange={handleChangeInput}
				onKeyDown={handleKeyDownInput}
				{...dataTestAttribute}
			/>
			<span
				className="searchbox-icon"
				aria-label={isFilter ? "Filter" : "Search"}
				title={isFilter ? "Filter" : "Search"}
				onClick={() => searchByClick(searchValue)}
				data-test-class="search-box-icon"
			>
				{isFilter ? <FontAwesomeIcon icon={faFilter} /> : <FontAwesomeIcon icon={faMagnifyingGlass} />}
			</span>
		</div>
	);
};

export default SearchBox;
